import { SetShortlistedCottagesButton } from './shortlist.js'; 

L.mapbox.accessToken = 'pk.eyJ1IjoiY2xhc3NpY2NvdHRhZ2VzIiwiYSI6ImNqMTNldmR5NDAwMGsycXJteG41aGxpb3MifQ.vgda8-nICmOzUiGEd6Quqw';

(function (window, undefined) {

    Date.prototype.addDays = function (days) {
        var dat = new Date(this.valueOf());
        dat.setDate(dat.getDate() + days);
        return dat;
    }

    Date.prototype.dateDiff = function (diffDate) {
        var thisDate = new Date(this.valueOf());
        return (diffDate.getTime() - thisDate.getTime()) / (24 * 3600 * 1000);
    }

    // Prepare our Variables
    var
        History = window.History,
        State = History.getState(),
        $ = window.jQuery,
        document = window.document;

    function checkEnter(e) {
        var characterCode;
        if (e && e.which) {
            e = e;
            characterCode = e.which;
        } else {
            e = event;
            characterCode = e.keyCode;
        }
        if (characterCode === 13) {
            document.forms[0].submit();
            return false;
        } else {
            return true;
        }
    }

    isElementInViewport = function (el) {

        if (typeof jQuery === "function" && el instanceof jQuery) {
            el = el[0];
        }

        var rect = el.getBoundingClientRect();

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
            rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
        );
    };
    // Check to see if History.js is enabled for our Browser
    if (!History.enabled) {
        return false;
    }



    // Wait for Document
    $(function () {


        search = {};

        //the form element
        search.$form = $('.search-control, .search-control-refine, .search-control-plus-minus, #property-list');

        if (search.$form.length === 0) {
            // not on a search page
            return;
        }

        /* VARIABLES */

        //xhr variables for deduping search requests
        search.loadContentXHR;
        search.loadContentCounter = 0;

        //xhr variables for deduping inner location requests
        search.subLocationXHR;
        search.subLocationCounter = 0;
        search.innerLocationToSelect = "";

        search.ideaUrl = null;

        search.pageMin = 1;
        search.pageMax = 1;
        search.loadIgnoreChange = false;
        search.loadIsShowMore = false;
        search.loadIsPageChange = false;
        search.previewImages = {};
        //check if form is ajax driven
        search.isAjax = function () { return search.$form.hasClass('ajax'); }
        //fetch any control within the form by selector
        search.controls = function (selector) { return this.$form.find(selector); };
        //fetch any control within the form by name
        search.controlsByName = function (name) { return this.$form.find("[name='" + name + "']"); };
        search.tracking = {};


        //reset the surrounding control, visiblility depends on location selected
        search.setDistanceVisiblity = function () {
            var locationId = this.controlsByName('location').val();
            //hide element if id equates to top level (Cornwall)
            this.$form.find('.destination-distance').toggleClass("hidden", locationId <= 1);
        };

        search.resetDistance = function () {
            this.setDistanceVisiblity();
            this.controlsByName('distance').val(0);
        };

        //clear sub regions control
        search.clearSubRegions = function () {
            this.controls("fieldset.sublocation").empty();
        }

        /* Datepicker and Shortbreak Logic */

        search.fromDateControl = null;
        search.toDateControl = null;

        search.initDatePickers = function () {
            var self = this;

            /* load datepicker into qtip popup */
            $('.date-input').each(function () {
                $(this).qtip({
                    prerender: true,
                    content: {
                        text: $('#search-control-date-modal').html()
                    },
                    position: {
                        viewport: $(window),
                        my: 'bottom center',
                        at: 'top center',
                        adjust: {
                            method: 'flip'
                        }
                    },
                    style: {
                        classes: 'qtip-light qtip-nopad'
                    },
                    show: 'click',
                    hide: 'unfocus',
                    events: {
                        hide: function (event, api) {
                            //change active for mobile (always revert to from date)
                            $('.datepicker-toggle-from').trigger('click');
                        }
                    }
                });
            });

            self.fromDateControl = $('.qtip .datepicker-from-date');
            self.toDateControl = $('.qtip .datepicker-to-date');

            /* take value of controls prior to datepicker setup*/
            var fromDateVal = this.controlsByName('from-date').val();
            var toDateVal = this.controlsByName('end-date').val();

            // Init from date
            self.fromDateControl.datepicker({
                dateFormat: 'yy-mm-dd',
                altField: '#from-date',
                firstDay: 1,
                minDate: new Date(),
                hideIfNoPrevNext: true,
                defaultDate: fromDateVal,
                onSelect: function (dateStr, inst) {
                    var fromDateVal = self.fromDateControl.datepicker('getDate') || new Date();
                    var toDateMin = new Date(fromDateVal);

                    toDateMin.setDate(fromDateVal.getDate() + 2);
                    self.toDateControl.datepicker('option', 'minDate', toDateMin);

                    if (self.controlsByName('los').val() == 0) self.controlsByName('los').val(7);

                    var toDateVal = new Date(fromDateVal);
                    toDateVal.setDate(toDateVal.getDate() + parseInt(self.controlsByName('los').val()));
                    self.toDateControl.datepicker('setDate', toDateVal);

                    //update ui element
                    self.setUIDateValues();

                    self.controlsByName('from-date').trigger('change');
                    //change active for mobile
                    $('.datepicker-toggle-to').trigger('click');
                }
            });

            // if date is blank or invalid, (re)clear the input and remove highlight from datepicker
            if (fromDateVal === "" || !moment(fromDateVal, 'YYYY-MM-DD').isValid()) {
                self.fromDateControl.datepicker('setDate', null);
                self.fromDateControl.find('.ui-state-active').removeClass('ui-state-active');
            }

            // Init to date
            self.toDateControl.datepicker({
                dateFormat: 'yy-mm-dd',
                altField: '#end-date',
                firstDay: 1,
                minDate: new Date(),
                defaultDate: toDateVal,
                hideIfNoPrevNext: true,
                onSelect: function (dateStr, inst) {
                    //update ui element
                    self.setUIDateValues();
                    self.controlsByName('end-date').trigger('change');
                    //close the modal
                    $('.date-input').trigger('unfocus');
                }
            });

            // if date is blank or invalid, (re)clear the input and remove highlight from datepicker
            if (toDateVal === "" || !moment(toDateVal, 'YYYY-MM-DD').isValid()) {
                self.toDateControl.datepicker('setDate', null);
                self.toDateControl.find('.ui-state-active').removeClass('ui-state-active');
            }

            $('.datepicker-toggle-from').click(function () {
                //change active date picker (for mobile)
                $('.datepicker-to, .datepicker-toggle-to').removeClass('active');
                $('.datepicker-from, .datepicker-toggle-from').addClass('active');
            });

            $('.datepicker-toggle-to').click(function () {
                //change active date picker (for mobile)
                $('.datepicker-from, .datepicker-toggle-from').removeClass('active');
                $('.datepicker-to, .datepicker-toggle-to').addClass('active');
            });
        }

        search.setUIDateValues = function (respectDuration) {
            var self = this;

            if (respectDuration === undefined) respectDuration = false;

            var fromMoment = moment(self.fromDateControl.datepicker('getDate'));
            if (!fromMoment.isValid()) return;
            var toMoment = moment(self.toDateControl.datepicker('getDate'));
            var currentDuration = parseInt(self.controlsByName('los').val());

            $('.date-input').addClass('set');
            $('.date-from').text(fromMoment.format('DD/MM/YY'));
            $('.date-to').text(toMoment.format('DD/MM/YY'));

            if (currentDuration > toMoment.diff(fromMoment, 'days')) {
                if (respectDuration) {
                    toMoment = moment(fromMoment).add('days', currentDuration);
                    self.toDateControl.datepicker('setDate', toMoment.toDate());
                    self.setUIDateValues(false);
                } else {
                    self.controlsByName('los').val(toMoment.diff(fromMoment, 'days'));
                }
            }
        }


        search.locationsControl = null;

        search.initLocations = function () {
            var self = this;

            var updateSearchMap = function () {
                if (self.searchMap == null) self.initSearchMap();
                self.locationsControl.fancyDDL('updateList');
                self.searchMap.invalidateSize();
                var wkt = self.locationsControl.fancyDDL('getParam', 'shape');
                var parentId = parseInt(self.locationsControl.fancyDDL('getParam', 'parent'));
                self.polylineFromString(wkt);

                if (parentId == 0) {
                    if (self.searchMap.hasLayer(self.searchMapShape)) {
                        self.searchMap.removeLayer(self.searchMapShape);
                    }
                } else {
                    if (!self.searchMap.hasLayer(self.searchMapShape)) {
                        self.searchMap.addLayer(self.searchMapShape);
                    }
                }
            };

            /* Location */
            $('.location-name').each(function () {
                $(this).qtip({
                    prerender: true,
                    content: {
                        text: $('#search-control-location-modal').html()
                    },
                    position: {
                        viewport: $(window),
                        my: 'bottom center',
                        at: 'top center',
                        adjust: {
                            method: 'flip'
                        }
                    },
                    style: {
                        classes: 'qtip-light qtip-nopad'
                    },
                    show: 'click',
                    hide: 'unfocus',
                    events: {
                        visible: updateSearchMap
                    }
                });
            });
            self.locationsControl = $('.qtip #location-list');
            self.locationsControl.fancyDDL({ input: 'input[name=location]', inputParam: 'val', display: 'tooltip', tooltipSelectedText: 'label.location-name' });
            self.controls('#location').change(updateSearchMap);
        }

        search.searchMap = null;
        search.searchMapShape = null;

        search.initSearchMap = function () {
            var self = this;
            self.searchMap = L.mapbox.map($('.qtip .location-picker-map')[0], null, {
                center: L.latLng(-34.397, 150.644),
                zoom: 8,
                minZoom: 8,
                scrollWheelZoom: false
            });
            //L.mapbox.styleLayer('mapbox://styles/classiccottages/cj13h5618002k2ro8wz8conil').addTo(self.searchMap);
            L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                tileSize: 256,
                minZoom: 1,
                attribution: 'Map data © <a href="https://openstreetmap.org">OpenStreetMap</a> contributors',
                crossOrigin: true
            }).addTo(self.searchMap);

            self.searchMapShape = L.polyline([], {
                weight: 3,
                color: "#9BCB5D",
                opacity: 1,
                fillColor: '#9BCB5D',
                fillOpacity: 0.5
            }).addTo(self.searchMap);
        }

        search.polylineFromString = function (shape) {
            var self = this;
            if (shape != "") {
                var parameters = shape.match(/([A-Z ]+)\([\(]?([0-9-. ,]+)\)[\)]?/);
                if (parameters) {
                    var coords = [];
                    var lls = parameters[2].split(",");
                    for (j = 0; j < lls.length; j++) {
                        var ll = $.trim(lls[j]);
                        var llarr = ll.split(" ");
                        var gll = L.latLng(llarr[1], llarr[0]);
                        coords.push(gll);
                    }
                    self.searchMapShape.setLatLngs(coords);
                    self.searchMap.fitBounds(self.searchMapShape.getBounds(), { maxZoom: 14, padding: [80, 80] });
                }
            }
        };


        search.isFlexibleDateRange = function () {
            var self = this;

            var fromMoment = moment(self.fromDateControl.datepicker('getDate'));
            if (!fromMoment.isValid()) return;
            var toMoment = moment(self.toDateControl.datepicker('getDate'));

            return self.controlsByName('los').val() < toMoment.diff(fromMoment, 'days');
        }


        search.ideaStoreParams = function () {
            search.ideaUrl = this.buildSearchUrl({ run: false, fetchingUrlForIdea: true });

        }

        search.searchQsToKVP = function (queryString) {
            const ignoredParameters = ["", "bname", "utm", "gac_source"];

            var params = new URLSearchParams(queryString);
            if (params.has("nlm") && !params.has("lcoid")) {
                //ignore nlm (near location miles) if no location set
                ignoredParameters.push("nlm");
            };

            var json = {};

            params.forEach(function (value, key) {
                if (!ignoredParameters.includes(key)) {
                    if (!json.hasOwnProperty(key)) {
                        json[key] = value;
                    } else {
                        if (!Array.isArray(json[key])) {
                            json[key] = [json[key]];
                        }
                        json[key].push(value);
                    }
                }
            });
            return json;
        }


        search.urlToKvp = function (url) {
            if (url.indexOf("/") == 0) {
                url = url.substring(1, url.length);
            }
            var urlArr = url.split("/");
            urlArr.shift(); //remove first as it will be 'cottages' or 'offers' etc.
            var urlKVP = {};
            for (i = 0; i < urlArr.length; i += 2) {
                urlKVP[urlArr[i]] = urlArr[i + 1];
            }
            return urlKVP;
        }

        search.kvpToUrl = function (kvp, root) {
            var url = '/' + root;
            $.each(kvp, function (k, v) {
                url += '/' + k + '/' + v;
            });
            return url;
        }

        search.urlRoot = function (url) {
            url = url.replace(/^\/+/g, '');
            return url.split('/')[0]
        }

        search.ideaStillValid = function (url) {
            var valid = false;
            if (this.ideaControlSet(url)) {
                // starting criteria is whether the root url still matches
                valid = this.urlRoot(this.ideaUrl) === this.urlRoot(url);

                if (!valid) return false

                var ideaKVP = this.urlToKvp(this.ideaUrl);
                var urlKVP = this.urlToKvp(url);
                $.each(ideaKVP, function (k, v) {
                    if (k !== "in" && k !== "near" && k !== '-') {
                        if (urlKVP[k] !== undefined) {
                            if (urlKVP[k] !== v) {
                                //if value in url does not match that in the idea (and its not location based) then no longer valid.
                                valid = false;
                            }
                        } else {
                            //if parameter was in idea but isnt present in url then no longer valid
                            valid = false;
                        }
                    }
                });
                $.each(urlKVP, function (k, v) {
                    if (k !== "in" && k !== "near" && k !== '-' && k !== 'page' && k !== 'within') {
                        if (typeof ideaKVP[k] === 'undefined') {
                            //if param is present in url but not idea then no longer a featured search
                            valid = false;
                        }
                    }
                });

                if (this.locationsControl.fancyDDL('getParam', 'fsvalid') == false) {
                    valid = false;
                }
            }
            return valid;
        }

        search.ideaModifiedUrl = function (url) {
            var newUrl = url;
            if (this.ideaControlSet(url)) {
                //remove parameters in initial url from new url
                var ideaKVP = this.urlToKvp(this.ideaUrl);
                var urlKVP = this.urlToKvp(newUrl);
                $.each(ideaKVP, function (k, v) {
                    if (urlKVP[k] != undefined) {
                        if (k != "idea" && urlKVP[k] == v) {
                            if (k != 'in' || urlKVP['-'] == undefined) {
                                delete urlKVP[k];
                            }
                        }
                    }
                });
                newUrl = this.kvpToUrl(urlKVP, this.urlRoot(this.ideaUrl));
            }
            return newUrl;
        }


        search.ideaControlUrl = function (controlUrl) {
            //add idea params that are missing to the control url
            if (this.ideaControlSet(controlUrl)) {
                var ideaKVP = this.urlToKvp(this.ideaUrl);
                var controlKVP = this.urlToKvp(controlUrl);
                $.each(ideaKVP, function (k, v) {
                    if (k == "near" && controlKVP["in"] != undefined) k = "in";
                    if (k == "in" && controlKVP["near"] != undefined) k = "near";

                    if (controlKVP[k] == undefined) {
                        controlKVP[k] = v;
                    }
                });
                controlUrl = this.kvpToUrl(controlKVP, this.urlRoot(this.ideaUrl));
            }
            return controlUrl;
        }

        search.ideaControlSet = function (url) {
            return url.indexOf('/idea') !== -1 && this.ideaUrl != null;
        }

        search.buildSearchUrl = function (opts) {
            var defaultOpts = { run: true, sort: null, minPage: null, maxPage: null, fetchingUrlForIdea: false };
            opts = $.extend({}, defaultOpts, opts);

            //base form controls
            var $location = this.locationsControl;
            var $fromDate = this.controlsByName('from-date');
            var $endDate = this.controlsByName('end-date');
            var $sleeps = this.controlsByName('sleeps');
            var $changeover = this.controlsByName('co');
            var $los = this.controlsByName('los');
            var $bed = this.controlsByName('bed');
            var $bath = this.controlsByName('bath');
            var $pets = this.controlsByName('pets');
            var $parking = this.controlsByName('parking');
            var $features = this.controlsByName('features[]');
            var $promotions = this.controlsByName('promotions[]');
            var $idea = this.controlsByName('idea');
            var $onSpecialOffer = this.controlsByName('oso');
            var $searchCode = this.controls("#search-code:visible, #search-code-tablet:visible");
            var ideaUrlComponent = "";

            var $specialOfferStarting = this.controlsByName('so-starting');
            var $specialOfferDuration = this.controlsByName('special-offer-duration');
            var $sortOrder = $('#sort-order');
            var setSort = true;

            if ($onSpecialOffer.is(':checked')) {
                this.$form.attr('rel', 'last-minute');
            } else {
                this.$form.attr('rel', this.$form.attr('action').substring(1));
            }

            //take base of the url from the rel parameter of the search form
            var url = '/' + this.$form.attr('rel');

            if ($location.length) {
                var inornear = "in", within = "", distance = 0, locationName;
                if (this.controlsByName("distance").length) {
                    distance = this.controlsByName("distance").val();
                    if (distance > 0) {
                        inornear = 'near';
                        within = '/within/' + distance;
                    }
                }
                var parentId = $location.fancyDDL('getParam', 'parent') || 0;
                if (parentId > 0) {
                    // if parentId = 0 then its the "root location" and doesn't need to be in the url
                    var locationStr = $location.fancyDDL('getParam', 'urlstring') || "";
                    var outerLocationStr = $location.fancyDDL('getParam', 'outerurlstring') || "";
                    if (outerLocationStr !== "") {
                        locationStr = outerLocationStr + '/-/' + locationStr;
                    }
                    url += '/' + inornear + '/' + locationStr + within;
                }
            }


            if ($searchCode.length) {
                if ($searchCode.val() != '') {
                    url += '/term/' + encodeURIComponent($searchCode.val());
                }
            }

            if ($fromDate.length) {
                if ($fromDate.val() != '' && $fromDate.val() != 'Any') {
                    url += '/start/' + encodeURIComponent($fromDate.val());
                }
            }

            if ($endDate.length && this.isFlexibleDateRange()) {
                if ($endDate.val() != '' && $endDate.val() != 'Any') {
                    url += '/end/' + encodeURIComponent($endDate.val());
                }
            }

            if ($specialOfferStarting.length) {
                if ($specialOfferStarting.val() != 0) {
                    url += '/so-starting/' + $specialOfferStarting.val();
                }
            }
            if ($specialOfferDuration.length) {
                if ($specialOfferDuration.val() != 0) {
                    url += '/so-duration/' + $specialOfferDuration.val();
                }
            }

            if ($idea.length) {
                if ($idea.val() != 0) {
                    url += '/idea/' + encodeURIComponent($idea.val());
                }
            }

            if ($sleeps.length) {
                if ($sleeps.val() != 0) {
                    url += '/sleeps/' + encodeURIComponent($sleeps.val());
                }
            }

            if ($changeover.length) {
                if ($changeover.val() > 0) {
                    url += '/co/' + encodeURIComponent($changeover.val());
                }
            }

            if ($los.length) {
                if ($los.val() != null && $los.val() != 0) {
                    url += '/los/' + encodeURIComponent($los.val());
                }
            }
            if ($bed.length) {
                if ($bed.val() > 0) {
                    url += '/bed/' + encodeURIComponent($bed.val());
                }
            }
            if ($bath.length) {
                if ($bath.val() > 0) {
                    url += '/bath/' + encodeURIComponent($bath.val());
                }
            }
            if ($pets.length) {
                if ($pets.val() > 0) {
                    url += '/pets/' + encodeURIComponent($pets.val());
                }
            }
            if ($parking.length) {
                if ($parking.val() > 0) {
                    url += "/parking/" + encodeURIComponent($parking.val());
                }
            }
            if ($features.length) {
                var values = [];
                $features.filter(':checked').each(function () {
                    values.push($(this).data("urlstring"))
                });
                if (values.length) {
                    url += '/features/' + encodeURIComponent(values.join('~'));
                }
            }

            if ($promotions.length) {
                var values = [];
                $promotions.filter(':checked').each(function () {
                    values.push($(this).val());
                });
                if (values.length) {
                    url += '/promotions/' + encodeURIComponent(values.join('~'));
                }
            }


            if (opts.minPage != null && opts.maxPage != null) {
                if (opts.minPage == opts.maxPage) {
                    if (opts.minPage > 1) {
                        // single page no
                        url += '/page/' + opts.minPage;
                    }
                } else {
                    // ranged page no
                    url += '/page/' + opts.minPage + '-' + opts.maxPage;
                }
            }

            if ($sortOrder.length) {
                if ($sortOrder.val() != 0) {
                    var defaultSortValue = $sortOrder.find('option[data-default="true"]').attr('value');
                    if ($sortOrder.val() != defaultSortValue) {
                        url += '/sorting/' + encodeURIComponent($sortOrder.val());
                    }
                }
            }


            if (opts.sort) {
                //if sort parameter passed into function, use it
                if (opts.sort != 0) {
                    url += '/sort/' + encodeURIComponent(opts.sort);
                }

            } else {
                //else try to find sort parameter in url
                var str = this.currentUrl();
                var matches = str.match('(sort\/([^/]+))');
                if (matches != null) {
                    url += '/' + matches[0];
                }
            }

            if (!opts.fetchingUrlForIdea && this.ideaControlSet(url) && !this.ideaStillValid(url)) {
                //idea is no longer valid, clear idea url,
                //remove value in control,
                //and re run build;
                $idea.val("");
                return search.buildSearchUrl(opts);
            }
            url = search.ideaModifiedUrl(url);

            if (opts.run) {
                History.pushState(null, 'Loading...', url);
            }

            return url;

        };

        search.showLoadingImage = function () {
            $('#search-wrapper #property-list').html('<div class="properties-loading"><img src="/images/ajax-loader-lg.gif" alt="loading" /></div>');
        };

        search.updateMap = function (url) {
            if (map != null) {
                updateMarkersForSearch(url);
            }
        }



        search.setPageFromUrl = function (url) {
            var matchRange = url.match('/page/([0-9]+)-([0-9]+)');
            var matchSingle = url.match('/page/([0-9]+)');
            if (matchRange != null) {
                this.pageMin = parseInt(matchRange[1]);
                this.pageMax = parseInt(matchRange[2]);
            } else if (matchSingle != null) {
                this.pageMin = parseInt(matchSingle[1]);
                this.pageMax = parseInt(matchSingle[1]);
            } else {
                this.pageMin = 1;
                this.pageMax = 1;
            }
        }

        search.setStateFromResults = function (title, url) {
            var s = History.getState();
            // create a hyperlink element to extract the root-relative path for comparison
            var a = document.createElement('a');
            a.href = s.url;
            // only replace state if it's actually changed, 
            if (url !== a.pathname || title !== s.title) {
                this.loadIgnoreChange = true;
                History.replaceState(s.data, title || s.title, url || a.pathname);
            }
        }

        search.loadContent = function (url) {
            var self = this, loadContentToken;
            this.setPageFromUrl(url);

            var controlUrl = url;
            if (this.ideaControlSet(url)) {
                controlUrl = this.ideaControlUrl(url);
            }
            if (!this.setSearchControlsFromUrl(controlUrl)) {
                //escape process as url state is uncertain
                //reload page to new url
                window.location.href = url;
                return;
            }


            $('.show-more a').addClass('inactive').addClass('hidden');

            this.showLoadingImage();
            if (!self.loadIsPageChange) {
                this.updateMap(url);
            }
            self.loadIsPageChange = false;

            //if there is an existing request in progress, abort it
            if (this.loadContentXHR) this.loadContentXHR.abort();
            //take the new value of the  xhr counter
            loadContentToken = ++this.loadContentCounter;
            //make the request
            this.loadContentXHR = $.get(url + '?&ajax=true', function (data) {
                //even aborted xhr may cause callback, so check using counter and return if they dont match
                if (loadContentToken != self.loadContentCounter) return;

                var $doc = $("<div>").append($.parseHTML(data));
                var title = $doc.find("#search-wrapper").attr("data-title");

                //log event to dataLayerQueue for cotalytics
                search.logPositionResults($doc.find('article.property-box'));
                //copy result into page
                $('#search-wrapper').replaceWith($doc.find('#search-wrapper'));

                search.floatNavigation();

                //set new page title in history
                self.setStateFromResults(title, self.buildSearchUrl({ run: false, minPage: self.pageMin, maxPage: self.pageMax }));
                // rewrite url from state to ensure consistency
                search.tracking.trackSearch()
                //log page view in google analytics
                dataLayerQueue.push({ 'event': 'pageView', 'virtualPageURL': State.url.replace(/^.*\/\/[^\/]+/, '') });


                setTimeout(function () { $('.show-more a').removeClass('inactive').removeClass('hidden'); }, 500);

                self.initSearchPanelEvents();
                self.setBreadcrumbs();
                self.setIntro();
                self.setSiteTagline();
                self.previewImages.loadVisibleResults();
                self.complexes.loadSwiper();
                SetShortlistedCottagesButton();
            }).done(function () {
                search.tracking.observeItems();
            });
        };

        search.loadMore = function (url) {
            var self = this, loadContentToken;

            search.setPageFromUrl(url);

            //if there is an existing request in progress, abort it
            if (this.loadContentXHR) this.loadContentXHR.abort();
            //take the new value of the  xhr counter
            loadContentToken = ++this.loadContentCounter;
            //make the request
            this.loadContentXHR = $.get(url + '?&ajax=true&showmore=true', function (data) {
                //even aborted xhr may cause callback, so check using counter and return if they dont match
                if (loadContentToken != self.loadContentCounter) return;

                var $doc = $("<div>").append($.parseHTML(data));
                var title = $doc.find("#search-wrapper").attr("data-title");

                //extract nav, results, expander and showMore from returned html
                var $nav, $results, $expander, $showMore;

                $nav = $doc.find('.search-pagination');
                $results = $doc.find('#property-list');
                $expander = $doc.find('.expand-property-search');
                $showMore = $doc.find('.show-more');

                $('.search-pagination').html($nav.html());
                $('.show-more').replaceWith($showMore);

                //log event to dataLayerQueue for cotalytics
                search.logPositionResults($results.find('article.property-box'));

                $('#property-list').append($results.find('.results-item'));
                if ($('.expand-property-search').length) {
                    $('.expand-property-search').empty();
                    if ($expander.length) {
                        $('.expand-property-search').replaceWith($expander);
                    }
                } else {
                    if ($expander.length) {
                        $('#property-list').after($expander);
                    }
                }

                self.setStateFromResults(title, self.buildSearchUrl({ run: false, minPage: self.pageMin, maxPage: self.pageMax }));

                //log page view in google analytics
                dataLayerQueue.push({ 'event': 'pageView', 'virtualPageURL': State.url.replace(/^.*\/\/[^\/]+/, '') });

                self.initSearchPanelEvents();

                $('.show-more a').removeClass('inactive').html('Show More');
                self.previewImages.loadVisibleResults();
                self.complexes.loadSwiper();
                SetShortlistedCottagesButton();

                //If Trust Pilot has dynamically loaded, load the widget
                if (window.Trustpilot) {
                    $('.trustpilot-widget').each(function () {
                        if (!$(this).find('iframe').length) {
                            window.Trustpilot.loadFromElement(this, true);
                        }
                    });
                }
            });
        }



        search.setBreadcrumbs = function () {
            //set breadcrumbs from those passed in results
            $("body>section#breadcrumbs").replaceWith($('#search-wrapper section#breadcrumbs'));
        }

        search.setIntro = function () {
            var display = $("body>.search-header-container header").css("display");
            $('#search-wrapper .search-header-container header').css("display", display);
            $("body>.search-header-container").replaceWith($('#search-wrapper .search-header-container'));
        }

        search.setSiteTagline = function () {
            var $location = this.controlsByName('location');
            $("#locationNameHeader").text($.trim(this.locationsControl.fancyDDL('text')));
        }

        search.setSearchControlsFromUrl = function (url) {
            var parsingSuccess = true;
            //reset all
            this.controlsByName('from-date').val('Any');
            this.controlsByName('end-date').val('Any');
            this.controlsByName('los').val(0).trigger('update');
            this.controlsByName('co').val(0);
            this.controlsByName('sleeps').val(0);
            this.controlsByName('distance').val(0);
            this.controlsByName('bed').val(0);
            this.controlsByName('bath').val(0);
            this.controlsByName('pets').val(0);
            this.controlsByName('parking').val(0);
            this.controlsByName('features[]').attr('checked', false);
            this.controlsByName('idea').val('');
            this.controlsByName('oso').attr('checked', false);
            this.controls('.special-offer-start').removeClass('selected');
            this.controlsByName('special-offer-duration').val(0);
            var locationSpecified = false;
            //set from url
            if (url.substring(0, 1) == "/") {
                url = url.substring(1, url.length);
            }
            var urlParts = url.split("/");
            var type = urlParts.shift();

            switch (type) {
                case 'last-minute':
                    this.controlsByName('oso').attr('checked', true);
                    break;
                case 'short-breaks':
                    this.controlsByName('los').val(3).trigger('update');
                    break;
            }

            for (i = 0; i < urlParts.length; i += 2) {
                var k = urlParts[i];
                var v = urlParts[i + 1];
                switch (k) {
                    case 'in':
                    case 'near':
                    case '-':
                        var locValBefore, locValAfter;
                        locValBefore = this.locationsControl.fancyDDL('value');
                        this.locationsControl.fancyDDL("select", { k: 'urlstring', v: v });
                        locValAfter = this.locationsControl.fancyDDL('value');

                        //location has changed, reset the 'include surrounding area' parameter (and hide if neccessary)
                        if (locValBefore != locValAfter) {
                            this.resetDistance();
                        }
                        locationSpecified = true;
                        break;
                    case 'within':
                        this.controlsByName('distance').val(v);
                        break;
                    case 'start':
                        this.controlsByName('from-date').val(v);

                        break;
                    case 'end':
                        this.controlsByName('end-date').val(v);
                        // set the correct date button in special offers to be selected if applicable
                        var startDate = this.controlsByName('from-date').val();
                        var endDate = v;

                        break;
                    case 'co':
                        this.controlsByName('co').val(v);
                        break;
                    case 'sleeps':
                        this.controlsByName('sleeps').val(v);
                        break;
                    case 'los':
                        this.controlsByName('los').val(v).trigger('update');

                        break;
                    case 'bed':
                        this.controlsByName('bed').val(v);
                        break;
                    case 'bath':
                        this.controlsByName('bath').val(v);
                        break;
                    case 'pets':
                        this.controlsByName('pets').val(v);
                        break;
                    case 'parking':
                        this.controlsByName('parking').val(v);
                        break
                    case 'features':
                        var featureParts = v.split('~');
                        for (j = 0; j < featureParts.length; j++) {
                            this.controlsByName('features[]').filter('[data-urlstring="' + featureParts[j] + '"]').attr('checked', true);
                        }
                        break;
                    case 'idea':
                        this.controlsByName('idea').val(v);
                        break;
                    case 'so-starting':
                        this.controlsByName('so-starting').val(v);
                        this.controls('.special-offer-start[data-val="' + v + '"]').addClass('selected');
                        break;
                    case 'so-duration':
                        this.controlsByName('special-offer-duration').val(v);
                        break;
                    case 'page':
                        break;
                    case 'sorting':
                        this.controlsByName('sort-order').val(v);
                        break
                    default:
                        //unrecognised url parameter, set flag to false to indicate unknown state
                        //might be only recognised server side.
                        parsingSuccess = false;
                        break;
                }
                if (!locationSpecified) {
                    this.controlsByName('location').find('option:first').attr("selected", true);
                    this.controls("fieldset.sublocation").empty();
                    this.resetDistance();
                }

            }

            this.changePlusMinusText(this.controlsByName('bed'));
            this.changePlusMinusText(this.controlsByName('bath'));
            this.changePlusMinusText(this.controlsByName('pets'));
            this.changePlusMinusText(this.controlsByName('parking'));

            return parsingSuccess;
        }


        search.initSearchPanelEvents = function () {
            var self = this;
            $('.paginator a, .back-to-first a, .forward-to-last a').click(function (e) {
                e.preventDefault();

                var clickedUrl = $(this).attr('href');
                self.loadIsPageChange = true;
                History.pushState(null, 'Loading...', clickedUrl);
            });

            $(".expand-property-search .extend-distance").click(function (e) {
                e.preventDefault();
                var distance = $(this).attr("data-distance");
                self.controlsByName('distance').val(distance);
                self.controls('.destination-distance').removeClass("hidden");
                self.buildSearchUrl();
            });

            $(".expand-property-search .clear-offer-filter").click(function (e) {
                e.preventDefault();
                self.controlsByName('oso').attr('checked', false);
                self.buildSearchUrl();
            });

            $('.show-more a').click(function (e) {
                e.preventDefault();

                if ($(this).hasClass('inactive')) return;

                var showMoreUrl = self.buildSearchUrl({ run: false, minPage: self.pageMin, maxPage: self.pageMax + 1 });
                self.loadIsShowMore = true;
                if (self.pageMin != self.pageMax) {
                    History.replaceState(null, 'Loading...', showMoreUrl);
                } else {
                    History.pushState(null, 'Loading...', showMoreUrl);
                }
                $(this).addClass('inactive').text('Loading...');
                search.showMoreAnimation();
            });

            $(window).unbind('scroll.infiniteScroll');

            $(window).bind('scroll.infiniteScroll', function () {
                var $button = $('.show-more a');
                var distanceFromPageTop = $(document).scrollTop();

                if ($button.length) {
                    var buttonDistBelowScreen = $button.position().top - distanceFromPageTop - $(window).height();
                    if (buttonDistBelowScreen < -100 && $button.is(':visible') && $button.text().indexOf('Loading') == -1) {
                        setTimeout(function () {
                            //check that after a second the button is still in view, if so click it!
                            var $button = $('.show-more a');
                            var distanceFromPageTop = $(document).scrollTop();
                            var buttonDistBelowScreen = $button.position().top - distanceFromPageTop - $(window).height();
                            if (buttonDistBelowScreen < -100 && $button.is(':visible') && $button.text().indexOf('Loading') == -1) {
                                $button.trigger('click');
                            }
                        }, 1000);
                    }
                }
            });

        }

        search.showMoreAnimation = function () {
            var self = this;
            $('.show-more a.inactive').animate({ 'background-color': '#DDDDDD' }, 1200, 'linear', function () {
                $('.show-more a.inactive').animate({ 'background-color': '#AAAAAA' }, 1200, 'linear',
                    self.showMoreAnimation());
            });
        }

        search.floatNavigation = function () {
            if ($('.floating-pagination').length && !$('#portamento_container_pagination').length) {
                $('.floating-pagination').portamento({ wrapper: $('#results-with-pagination'), gap: 0, containerId: 'portamento_container_pagination' });
            }
        }

        search.currentUrl = function () {
            var State = History.getState();
            var url = State.cleanUrl.replace(/^.*\/\/[^\/]+/, '');
            return url;
        }

        //initialise the ajax search
        search.init = function () {

            var self = this;
            this.initDatePickers();
            this.initLocations();

            if ($('html.ie8, html.ie7').length) {
                $('#search-code').keyup(function (eventObject) {
                    try {
                        checkEnter(eventObject);
                    } catch (err) {
                        $('div#find-form #findForm .submit').click();
                    }
                });
            }

            this.controlsByName('los').on('change', function () {
                //los has been changed, we might need to change the end date
                self.setUIDateValues(true);
            });

            $(window).on('resize', function () {
                self.controlsByName("name").filter(':not(:visible)').attr('disabled', true);
                self.controlsByName("name").filter(':visible').attr('disabled', false);
            }).resize();

            this.controlsByName("name").on('blur', function () {
                self.controlsByName("name").val($(this).val());
            });


            $('#bed').change(function (e) {
                self.buildSearchUrl();
            });

            $('#bath').change(function (e) {
                self.buildSearchUrl();
            });

            $('#pets').change(function (e) {
                self.buildSearchUrl();
            });
            $('#parking').change(function (e) {
                self.buildSearchUrl();
            });
            $('#on-offer').change(function () {
                self.buildSearchUrl();
            });
            $(document).on("change", "#sort-order", function (e) {
                self.buildSearchUrl();
            });


            this.controlsByName('los').on('change update', function (e) {
                if (self.controls('.button-los').length) {
                    self.controls('.button-los').removeClass('selected');
                    if ($(e.target).val() > 0) {
                        self.controls('.button-los[data-los=' + $(e.target).val() + ']').addClass('selected');
                    }
                }
            })


            if (this.isAjax()) {
                search.setPageFromUrl(this.currentUrl());

                //add event listener for page navigation (back/forward)
                var startingPath = location.pathname;

                History.Adapter.bind(window, 'statechange', function () { // Note: We are using statechange instead of popstate

                    if (!self.loadIgnoreChange) {
                        State = History.getState();
                        //load the page
                        var url = self.currentUrl();
                        if (startingPath.length == 0 || url != startingPath) {
                            if (self.loadIsShowMore) {
                                self.loadIsShowMore = false;
                                self.loadMore(url);
                            } else {
                                self.loadContent(url);
                            }
                        }

                        startingPath = "";
                    } else {
                        self.loadIgnoreChange = false;
                    }
                });

                //on change of any selectbox run search
                this.controls("select").on("change", function (e) {
                    self.buildSearchUrl();
                });

                // change event of date inputs (triggered by datepicker code)
                this.controlsByName("from-date").on("change", function (e) {
                    self.buildSearchUrl();
                });
                this.controlsByName("end-date").on("change", function (e) {
                    self.buildSearchUrl();
                });

                this.locationsControl.on('change', function (e) {
                    self.resetDistance();
                    self.buildSearchUrl();
                });

                //on change of sort run search
                this.controls('#sort-by').on('change', function () {
                    self.buildSearchUrl({ sort: $(this).val() });
                });

                //on changing selected features run search
                this.controlsByName('features[]').on('click', function () {
                    self.buildSearchUrl();
                });

                this.controlsByName('pets-home').on('click', function () {
                    self.buildSearchUrl();
                });

                //on changing selected promotions run search
                this.controlsByName('promotions[]').on('click', function () {
                    self.buildSearchUrl();
                });
                //plus and minus controls
                this.controls('.plus').on('click', function (e) {
                    e.preventDefault();
                    var $input = $(this).parent().children("input");
                    var maxVal = $input.attr('data-max');
                    var newVal = parseInt($input.val()) + 1;
                    var ThisControlName = $input.attr("data-parentName");

                    if (newVal <= maxVal) {
                        self.controlsByName(ThisControlName).val(newVal).trigger('change');
                        search.changePlusMinusText($input);
                    }
                });

                this.controls('.minus').on('click', function (e) {
                    e.preventDefault();
                    var $input = $(this).parent().children("input");
                    if ($input.val() > 0) {
                        var newVal = parseInt($input.val()) - 1;
                        var ThisControlName = $input.attr("data-parentName");
                        self.controlsByName(ThisControlName).val(newVal).trigger('change');
                        search.changePlusMinusText($input);
                    }
                });
                this.controls('.button-los').on('click', function (e) {
                    e.preventDefault();
                    var los = $(this).attr('data-los');
                    if (los != undefined) {
                        self.controlsByName('los').val(los).trigger('change');
                    }
                });

                this.controls('.special-offer-start').on('click', function (e) {
                    e.preventDefault();

                    if ($(this).hasClass('selected')) {
                        $(this).removeClass('selected');
                    } else {
                        self.controls('.special-offer-start').removeClass('selected');
                        $(this).addClass('selected');
                    }

                    // set drop down from this
                    if (self.controls('.special-offer-start.selected').length) {
                        self.controlsByName('so-starting').val(self.controls('.special-offer-start.selected').attr('data-val'));
                    } else {
                        self.controlsByName('so-starting').val(0);
                    }
                    self.controlsByName('so-starting').trigger('change');
                });

                this.initSearchPanelEvents();

                if (this.controlsByName('idea').val()) {
                    this.ideaStoreParams();
                }
                this.setDistanceVisiblity();

                this.floatNavigation();

                search.logPositionResults($('#property-list').children());

                search.logComplexClicks();

                // If pushState is emulated (html4 browsers) and we have a hash (a '#' in the url) trigger the statechange event
                if (History.emulated.pushState && History.getHash()) {
                    History.Adapter.trigger(window, "statechange");
                }
            }
        }
        search.changePlusMinusText = function (ctl) {
            const control = $(ctl);
            const selectedValue = parseInt(control.val());
            let text = selectedValue !== 1
                ? control.parent().children("p").attr("data-plural")
                : control.parent().children("p").attr("data-singular");

            text = selectedValue === 0
                ? text.replace("{0}", "")
                : text.replace("{0}", selectedValue);

            control.parent().children('p').text(text);
        };



        //log event for cotalytics
        search.logPositionResults = function (list) {
            for (var i = 0; i < list.length; i++) {
                dataLayerQueue.push({ 'event': 'cottageImpression', 'cottageCode': list[i].dataset.code, 'position': list[i].dataset.position });
            }
        };

        search.logComplexClicks = function () {
            $('#search-wrapper').parent().on('click', '.complex .complex-carousel .swiper-slide a', function () {
                var complexCode = $(this).closest('.complex').attr('data-code');
                dataLayerQueue.push({ 'event': 'complexCottageClick', 'complexCode': complexCode });
            });
        };

        search.previewImages.init = function () {
            // initialise cycle slideshows

            $('.result-nav>span').on('click', function (e) {
                e.stopPropagation();
            });

            search.previewImages.build();
            search.previewImages.loadVisibleResults();
            // scroll event - as each image comes into view, load additional images
            $(window).on('DOMContentLoaded load resize scroll', search.previewImages.loadVisibleResults);
        };

        search.previewImages.build = function () {
            $('.preview-gallery:not(.swiper-init)').each(function (e) {
                $(e).addClass('swiper-init');
            });
        };

        search.previewImages.loadVisibleResults = function () {
            $('.preview-gallery').each(function () {
                if (isElementInViewport(this) && !$(this).hasClass('loaded')) {
                    $(this).addClass('loaded');

                    var cottagecode = $(this).data('code');
                    var id = 'p' + cottagecode;
                    var year = $(this).data('year');
                    var swiperGallery = $(this);

                    var imagesToGet = 6;
                    $.ajax({
                        url: "/feeds/cottageListPics.aspx",
                        data: { code: id, year: year, count: imagesToGet },
                        dataType: "xml",
                        success: function (data) {
                            var imageCount = $(data).find("pictures").attr('count');
                            imageCount = imageCount - imagesToGet + 1;
                            $(data).find("picture").each(function (i) {
                                if (i > 0) {
                                    if (!$("img[src='" + $(this).attr("url") + "']", previewGallery).length) {
                                        var img = $('<img>').attr("src", $(this).attr("url"));
                                        $(img).addClass('preview-image');

                                        var figure;
                                        if (i === imagesToGet - 1) {
                                            figure = $('<figure data-imageCount="' + imageCount + '" class="property-image swiper-slide">').append(img);
                                        } else {
                                            figure = $('<figure class="property-image swiper-slide">').append(img);
                                        }
                                        swiperGallery.find('.swiper-wrapper').append(figure);
                                    }
                                }
                            });
                            var previewGallery = new Swiper('.preview-gallery[data-code="' + cottagecode + '"]', {
                                spaceBetween: 8,
                                autoHeight: false,
                                navigation: {
                                    prevEl: '.result-nav div.prev',
                                    nextEl: '.result-nav div.next',
                                },
                                loop: false
                            });

                            previewGallery.on('click', function (previewGallery, e) {
                                if ($(e.target).hasClass('preview-nav') === false && $(e.target).parent().hasClass('preview-nav') === false) {
                                    var code = $(e.target).parents('.preview-gallery').attr('data-code')
                                    var url = $('a[data-code="' + code + '"]').attr('href');
                                    window.location.href = url;
                                }
                            });

                        }
                    });

                }
            });
        };
        search.forms = {}
        search.forms.actualControlId = function (controlId) {

            if (document.getElementById(controlId)) {
                return controlId;
            } else {
                return $('[id$="' + controlId + '"]').attr('id');
            }
        }
        search.tracking.observeItems = function () {
            var resultsItems = [].slice.call(document.querySelectorAll('.property-box'))

            for (var i = 0, len = resultsItems.length; i < len; i++) {
                search.tracking.resultsItemObserver.observe(resultsItems[i])
            }
        }
        search.tracking.commonSearchParamControl = function (ctlId) {
            if ($(search.forms.actualControlId(ctlId))) {
                var ctl = $('#' + search.forms.actualControlId(ctlId));
                if (ctl.val() !== ctl.attr('data-defaultcontrolvalue')) {
                    return ctl
                } else {
                    return ''
                }
            }
        }

        search.tracking.trackSearch = function () {
            var resultsCount = $("#search-wrapper .count").text();
            var fromDateCtl = $('.date-from');
            var toDateCtl = $('.date-to');
            var url = search.currentUrl();
            var fromDate = fromDateCtl.text() == 'any' || typeof (fromDateCtl.text()) == 'undefined' ? '' : fromDateCtl.text();
            var toDate = toDateCtl.text() == 'any' || typeof (toDateCtl.text()) == 'undefined' ? '' : toDateCtl.text();

            var location = $('.location-name').text();

            window.dataLayerQueue.push({
                'event': 'Search'
                , 'arrivalDate': fromDate
                , 'departureDate': toDate
                , 'pets': $('#pets').val()
                , 'party': $('#sleeps').find(":selected").val()
                , 'nights': $('#los').find(":selected").val()
                , 'location': location
                , 'bedrooms': $('#bed').val()
                , 'bathrooms': $('#bath').val()
                , 'resultsCount': resultsCount
                , 'sortOrder': $('#sort-order option:selected').attr('value')
                , 'searchQuery': url
                , 'searchParams': search.tracking.searchQsToJSON(url)
            });
        }
        search.tracking.trackResultsItemViewed = function (cottage) {
            window.dataLayerQueue.push({
                'event': 'resultsItemViewed'
                , 'cottageCode': typeof (cottage.cottageCode) === 'undefined' ? '' : cottage.cottageCode
                , 'position': typeof (cottage.position) === 'undefined' ? '' : cottage.position
                , 'searchQuery': typeof (cottage.queryString) === 'undefined' ? '' : cottage.queryString
                , 'searchParams': typeof (cottage.params) === 'undefined' ? '' : JSON.stringify(cottage.params)
                , 'commonSearchParams': typeof (cottage.params) === 'undefined' ? '' : JSON.stringify(cottage.rawQs)
            });
        }
        search.tracking.trackComplexResultViewed = function (complex) {
            window.dataLayerQueue.push({
                'event': 'resultsComplexViewed'
                , 'complexCode': typeof (complex.complexCode) === 'undefined' ? '' : complex.complexCode
                , 'cottageCodes': typeof (complex.complexCodes) === 'undefined' ? '' : complex.complexCodes
                , 'position': typeof (complex.position) === 'undefined' ? '' : complex.position
                , 'searchQuery': typeof (complex.queryString) === 'undefined' ? '' : complex.queryString
                , 'searchParams': typeof (complex.params) === 'undefined' ? '' : JSON.stringify(complex.params)
                , 'commonSearchParams': typeof (complex.params) === 'undefined' ? '' : JSON.stringify(complex.rawQs)
            });
        }

        search.tracking.resultsItemObserver = new IntersectionObserver(function (entries) {
            for (var i = 0; i < entries.length; i++) {
                var entry = entries[i];
                if (entry.isIntersecting || entry.intersectionRatio > 0) {
                    var item = entry.target;
                    var position = item.getAttribute('data-position');

                    var qs = search.buildSearchUrl({ run: false })
                    var params = search.urlToKvp(qs);
                    var rawQs = search.searchQsToKVP($('.save-search-button').attr('data-searchquery'));

                    if (item.classList.contains('property-box') && item.attributes.getNamedItem('data-logged') === null) {
                        if (item.classList.contains('complex')) {
                            var complexCode = item.getAttribute('data-code');
                            var complexCottages = [];

                            var cElements = item.querySelectorAll('.swiper-slide');
                            for (var j = 0; j < cElements.length; j++) {
                                var c = cElements[j];
                                complexCottages.push(c.getAttribute('data-complexCottageCode'));
                            }

                            var complexCodes = JSON.stringify(complexCottages);
                            var complex = { 'complexCode': complexCode, 'complexCodes': complexCodes, 'position': position, 'queryString': qs, 'params': params, 'rawQs': rawQs };
                            search.tracking.trackComplexResultViewed(complex);
                            item.setAttribute('data-logged', 'true');
                        } else {
                            var cottageCode = item.getAttribute('data-code');
                            //if the item in view is a complex, log that the complex collection has been seen and also the individual cottages of the complex

                            ////log a cottage view when the results item has been seen
                            var cottage = { 'cottageCode': cottageCode, 'position': position, 'queryString': qs, 'params': params, 'rawQs': rawQs };
                            search.tracking.trackResultsItemViewed(cottage);
                            item.setAttribute('data-logged', 'true');
                        }
                    }
                }
            }
        }, {
            threshold: 0.3
        });

        search.tracking.observeItems();

        search.tracking.searchQsToJSON = function (queryString) {
            var params = new URLSearchParams(queryString);
            var json = {};

            params.forEach(function (value, key) {
                if (!json.hasOwnProperty(key)) {
                    json[key] = value;
                } else {
                    if (!Array.isArray(json[key])) {
                        json[key] = [json[key]];
                    }
                    json[key].push(value);
                }
            });
            return JSON.stringify(json);
        }


        search.tracking.commonSearchParamControl = function (ctlId) {
            if (jQuery(search.forms.actualControlId(ctlId))) {
                var ctl = $('#' + search.forms.actualControlId(ctlId));
                if (ctl.val() !== ctl.attr('data-defaultcontrolvalue')) {
                    return ctl
                } else {
                    return ''
                }
            }
        }

        search.complexes = {};

        search.complexes.loadSwiper = function () {
            if (typeof Swiper !== 'undefined') {
                $('.property-box .complex-carousel:not(.loaded)').each(function () {
                    var thisSwiper = new Swiper(this, {
                        slidesPerView: 'auto',
                        spaceBetween: 20,
                        autoHeight: false,
                        navigation: {
                            prevEl: '.result-nav div.prev',
                            nextEl: '.result-nav div.next',
                        },
                        pagination: '.swiper-pagination',
                        paginationClickable: true,
                        loop: false
                    });
                    $(this).addClass('loaded');
                });
            }
        };

        search.previewImages.init();
        search.complexes.loadSwiper();
        search.init();


    }); // end onDomLoad



})(window);
// end closureL.mapbox.accessToken = 'pk.eyJ1IjoiY2xhc3NpY2NvdHRhZ2VzIiwiYSI6ImNqMTNldmR5NDAwMGsycXJteG41aGxpb3MifQ.vgda8-nICmOzUiGEd6Quqw';
// end closure



